import script from "./OfferModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferModal.vue?vue&type=script&setup=true&lang=ts"

import "./OfferModal.vue?vue&type=style&index=0&id=0af946c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af946c1"]])

export default __exports__